<template>
    <QuestionAbstract>

        <template #title>
            {{ formattedQuestion }}
        </template>

        <template #content>
            <v-textarea 
                hide-details 
                color="color1"
                v-model="answer" 
                @input="handleAnswer">
            </v-textarea>
        </template>

    </QuestionAbstract>
</template>

<script>
import QuestionAbstract from '@/components/survey/question/QuestionAbstract.vue'

export default {
    name: 'QuestionText',
    components: {
        QuestionAbstract
    },
    props: {
        index: {
            type: Number,
            required: true
        },
        question: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            answer: ''
        }
    },
    computed: {
        formattedQuestion() {
            return `${this.index + 1}. ${this.question}`
        }
    },
    emits: ['answer'],
    methods: {
        handleAnswer() {
            this.$emit('answer', this.index, this.answer)
        }
    }
}
</script>